const API_URL_V2 = import.meta.env.VITE_GETSIGN_API_URL_V2;

export const initiateStripePayment = async ({
  item,
  itemId,
  fileHistoryId,
  activeFileId,
}) => {
  const res = await fetch(
    `${API_URL_V2}/stripe/checkout/${itemId}/${fileHistoryId}/${activeFileId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        paymentId: item?.id,
      }),
    },
  );

  if (!res.ok) {
    return { status: res.status, ...(await res.json()) };
  }

  const response = await res.json();
  return response;
};
